import React, { useState } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import { useForm } from '@formspree/react';

const ContactForm = (props) => {
  // Destructure Formspree state and submission handler
  const [state, formspreeSubmit] = useForm("mqaejlvk");

  // Local state for form values
  const [forms, setForms] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    message: ''
  });

  // Initialize validator
  const [validator] = useState(new SimpleReactValidator({
    className: 'errorMessage'
  }));

  // Handle input change
  const changeHandler = (e) => {
    setForms({ ...forms, [e.target.name]: e.target.value });
    // Dynamically show/hide error messages as user types
    if (validator.allValid()) {
      validator.hideMessages();
    } else {
      validator.showMessages();
    }
  };

  // Custom submit handler: validate then submit via Formspree
  const onSubmit = async (e) => {
    e.preventDefault();
    if (validator.allValid()) {
      validator.hideMessages();
      // Submit form using Formspree's handler
      await formspreeSubmit(e);
      // Reset form state (optional, as success message is shown)
      setForms({
        name: '',
        email: '',
        company: '',
        phone: '',
        message: ''
      });
    } else {
      validator.showMessages();
    }
  };

  // If the form submission is successful, show the success message.
  if (state.succeeded) {
    return (
      <div className="success-message">
        <h2>Thank You!</h2>
        <p>Your message has been sent successfully.</p>
      </div>
    );
  }

  return (
    <form className="xb-item--form contact-form" onSubmit={onSubmit}>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="input_title" htmlFor="input_name">
              <i className="fa-regular fa-user"></i>
            </label>
            <input
              value={forms.name}
              type="text"
              name="name"
              className="form-control"
              onBlur={changeHandler}
              onChange={changeHandler}
              placeholder="Your Name" />
            {validator.message('name', forms.name, 'required|alpha_space')}
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label className="input_title" htmlFor="input_email">
              <i className="fa-regular fa-envelope"></i>
            </label>
            <input
              value={forms.email}
              type="email"
              name="email"
              className="form-control"
              onBlur={changeHandler}
              onChange={changeHandler}
              placeholder="Your Email" />
            {validator.message('email', forms.email, 'required|email')}
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label className="input_title" htmlFor="input_phone">
              <i className="fa-regular fa-phone-volume"></i>
            </label>
            <input
              value={forms.phone}
              type="tel"
              name="phone"
              className="form-control"
              onBlur={changeHandler}
              onChange={changeHandler}
              placeholder="Your Phone No." />
            {validator.message('phone', forms.phone, 'required|phone')}
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label className="input_title" htmlFor="input_company">
              <i className="fa-regular fa-globe"></i>
            </label>
            <input
              value={forms.company}
              type="text"
              name="company"
              className="form-control"
              onBlur={changeHandler}
              onChange={changeHandler}
              placeholder="Your Company Name" />
            {validator.message('company', forms.company, 'required')}
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <label className="input_title" htmlFor="input_textarea">
              <i className="fa-regular fa-comments"></i>
            </label>
            <textarea
              onBlur={changeHandler}
              onChange={changeHandler}
              value={forms.message}
              name="message"
              className="form-control"
              placeholder="How can we help you?" />
            {validator.message('message', forms.message, 'required')}
          </div>
          <button type="submit" className="btn btn-primary">
            <span className="btn_label" data-text="Send Request">Send Request</span>
            <span className="btn_icon">
              <i className="fa-solid fa-arrow-up-right"></i>
            </span>
          </button>
        </div>
      </div>
    </form>
  );
};

export default ContactForm;
